<template>
  <div id="currency">
    <div class="update-box">
      <div class="material-info">
        <div class="material-details">
          <div class="img-details">
            <div class="title">个人身份证国徽面彩色照</div>
            <div class="img-box" v-if="imgPositiveInfo">
              <el-image :src="imgPositiveInfo.url" fit="contain"></el-image>
              <el-image-viewer
                v-if="showViewer=='positive'"
                :on-close="()=>{showViewer=-1}"
                :url-list="[imgPositiveInfo.url]"
              />
              <div class="img-info">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="imgPositiveInfo.fileName"
                  placement="top"
                >
                  <div class="img-name">{{imgPositiveInfo.fileName|valLength(15)}}</div>
                </el-tooltip>

                <div class="img-size">文件大小：{{imgPositiveInfo.length|changeSize}}</div>
                <div class="img-btn">
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uplaodPositiveMaterialsInfo"
                    :disabled="isDisabled"
                    @click.native="showDisable"
                  >重新上传</el-upload>
                  <div class="btn" @click="showViewer='positive'">预览</div>
                  <div class="btn" @click="downLoadFile(imgPositiveInfo)">下载</div>
                  <div class="btn" @click="deltetOpen('身份证原件照片（正面）',imgPositiveInfo)">删除</div>
                </div>
              </div>
            </div>
            <div class="img-update" v-else>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodPositiveMaterialsInfo"
                :disabled="isDisabled"
                @click.native="showDisable"
              >
                <div class="upload-tips">
                  <img src="@/assets/image/idcard-positive.jpg" alt="">
                </div>
              </el-upload>
            </div>
          </div>
          <div class="img-details">
            <div class="title">个人身份证人像面彩色照</div>
            <div class="img-box" v-if="imgBackInfo">
              <el-image :src="imgBackInfo.url" fit="contain"></el-image>
              <el-image-viewer
                v-if="showViewer=='back'"
                :on-close="()=>{showViewer=-1}"
                :url-list="[imgBackInfo.url]"
              />
              <div class="img-info">
                <div class="img-name">{{imgBackInfo.fileName|valLength(15)}}</div>
                <div class="img-size">文件大小：{{imgBackInfo.length|changeSize}}</div>
                <div class="img-btn">
                  <!-- <div class="btn">重新上传</div> -->
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uplaodBackMaterialsInfo"
                    :disabled="isDisabled"
                    @click.native="showDisable"
                  >重新上传</el-upload>
                  <div class="btn" @click="showViewer='back'">预览</div>
                  <div class="btn" @click="downLoadFile(imgBackInfo)">下载</div>
                  <div class="btn" @click="deltetOpen('身份证原件照片（反面）',imgBackInfo)">删除</div>
                </div>
              </div>
            </div>
            <div class="img-update" v-else>
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodBackMaterialsInfo"
                :disabled="isDisabled"
                @click.native="showDisable"
              >
                <div class="upload-tips">
                  <img src="@/assets/image/idcard-negative.jpg" alt="">
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMaterials,
  uploadMaterials,
  deleteMaterials,
  downloadMaterials,
} from "@/http/api/employe";


export default {
  props: {
    isLoadingImg: Boolean,
  },
  name: "Index",
  components: {
    "el-image-viewer": () =>
      import("@aiwins/admin-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      headerText: this.$route.query.type,
      id: this.$route.params.id,
      imgBackInfo: {},
      imgPositiveInfo: {},
      showViewer: -1,
      loadingImg: true,
      isPIC: true,
      isLt5M: true,
      isDisabled: true,
      permissions: this.$store.getters.permissions,
    };
  },
  watch: {
    isLoadingImg(val) {
      this.loadingImg = this.isLoadingImg;
    },
  },
  mounted() {
    this.getMaterialList();
    this.isDisabled = !this.permissions["RocketIdentity.Users.UploadMaterials"];
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无电子档案上传权限`,
          showClose: true,
        });
      }
    },
    downLoadFile(item) {
      if (this.permissions["RocketIdentity.Users.DownloadMaterials"]) {
        var data = item.url.split("/");
        var name = data[data.length - 1];
        let query={
          fileName:name
        }
        downloadMaterials(this.id,query).then(res=>{
          //console.log(res,'获取的下载数据');
          const content = res;
          //console.log(res);
          const blob = new Blob([content]);
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = name
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, name)
          }
        })
        // window.open(
        //   `https://api-dev.zhilexinfang.com/api/deer/users/${this.id}/download-materials?fileName=${name}`
        // );
      } else {
        this.$message.warning({
          message: `您暂无电子档案下载权限`,
          showClose: true,
        });
      }
    },
    deltetOpen(val, file) {
      if (this.permissions["RocketIdentity.Users.ManageMaterials"]) {
        //console.log(file, "获取的file");
        this.$confirm(`你确定要删除吗?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.deltetMaterial(val, file);
          })
          .catch(() => {
            //console.log("取消删除");
          });
      } else {
        this.$message.warning({
          message: `您暂无电子档案管理权限`,
          showClose: true,
        });
      }
    },
    deltetMaterial(val, file) {
      //console.log(val, "获取的删除信息");
      let data = `?Type=${val}&MaterialIds=${file.id}`;
      deleteMaterials(this.id, data).then((res) => {
        //console.log(res, "删除后");
        this.$message({
          message: "资料删除成功！",
          type: "success",
        });
        this.getMaterialList();
      });
    },
    getMaterialList() {
      let query = `?types=身份证原件照片（正面）&types=身份证原件照片（反面）`;
      this.imgPositiveInfo = null;
      this.imgBackInfo = null;
      getMaterials(this.id, query).then((res) => {
        res.result.items.map((item) => {
          if (item.type == "身份证原件照片（正面）") {
            this.imgPositiveInfo = item;
          } else if (item.type == "身份证原件照片（反面）") {
            this.imgBackInfo = item;
          }
        });
        this.loadingImg = false;
        setTimeout(() => {
          this.$emit("isLoading", this.loadingImg);
        }, 500);
      });
    },
    uplaodBackMaterialsInfo(req) {
      //console.log(req, "获取的文件数据");
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", "身份证原件照片（反面）");
      formData.append("Files", file);
      this.imgBackInfo
        ? formData.append("EnableClearUpTheMaterialsForThisType", true)
        : formData.append("EnableClearUpTheMaterialsForThisType", false);
      if (this.isPIC && this.isLt5M) {
        uploadMaterials(this.id, formData).then((res) => {
          this.$message({
            message: "身份证原件照片（反面）上传成功！",
            type: "success",
          });
          this.getMaterialList();
        });
      }
    },
    uplaodPositiveMaterialsInfo(req) {
      //console.log(req, "获取的文件数据");
      const file = req.file;
      var formData = new FormData();
      formData.append("Type", "身份证原件照片（正面）");
      formData.append("Files", file);
      this.imgPositiveInfo
        ? formData.append("EnableClearUpTheMaterialsForThisType", true)
        : formData.append("EnableClearUpTheMaterialsForThisType", false);
      uploadMaterials(this.id, formData).then((res) => {
        this.$message({
          message: "身份证原件照片（正面）上传成功！",
          type: "success",
        });
        this.getMaterialList();
      });
    },
    beforeAvatarUpload(file) {
      //console.log(file, "获取的file");
      this.isPIC = file.type === "image/jpeg" || file.type === "image/png";
      this.isLt5M = file.size / 1024 / 1024 < 5;
      if (!this.isPIC) {
        this.$message.error("只支持上传jpg/png文件");
      }
      if (!this.isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return this.isPIC && this.isLt5M;
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#currency {
  .update-box {
    @include flex(row, center);
    flex-wrap: wrap;
    .material-info {
      margin-bottom: 20px;
      .card-tit {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666666;
      }
      .material-details {
        @include flex(row, center);
        flex-wrap: wrap;
        justify-content: flex-start;
        .img-details {
          .title {
            margin-bottom: 20px;
            color: #666;
          }
        }

        .img-box {
          @include flex(row, flex-end);
          margin-right: 20px;
          padding: 10px;
          border: 1px solid #dfdfdf;
          .el-image {
            width: 170px;
            height: 148px;
            text-align: center;
            // @include flex(column,center);
            // justify-content: center;
            display: flex;
            align-items: center;
            ::v-deep .el-image__inner {
              width: 170px;
              height: auto;
            }
          }
          ::v-deep .el-image-viewer__close {
            color: #fff;
          }
          .img-info {
            margin-left: 10px;
            margin-bottom: 20px;
            .img-name {
              margin-bottom: 10px;
            }
            .img-btn {
              @include flex(row, center);
              margin-top: 10px;
              width: 180px;
              height: 12px;
              line-height: 12px;
              .upload-demo {
                margin-right: 10px;
                cursor: pointer;
                font-size: 12px;
                color: $--color-primary;
              }
              .btn {
                margin-right: 10px;
                cursor: pointer;
                font-size: 12px;
                color: $--color-primary;
              }
              .upload-file {
                display: none;
              }
            }
          }
        }
        .img-update {
          @include flex(row, center);
          justify-content: flex-start;
          width: 390px;
          .upload-tips {
            color: #bbb;
            img{
              
            margin-left: -10px;
            }
            span {
              font-size: 12px;
              color: $--color-primary;
            }
          }
        }
        // margin-bottom: 12px;
        ::v-deep .el-upload-dragger {
          border: 0;
        }
        ::v-deep .img-update .el-upload {
          border-radius: 0px;
          width: 350px;
          height: 170px;
          line-height: 190px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        ::v-deep .el-upload--picture-card {
          margin-right: 40px;
          width: 350px;
          height: 150px;
          border-radius: 0;
          border-color: #ddd;
        }
        .img-update .el-upload:hover {
          border-color: #409eff;
        }

        .avatar {
          @include flex(row, center);
          width: 178px;
          height: 400px;
          img {
            width: 50%;
            height: 100%;
          }
          .img-info {
            width: 100%;
            height: 100%;
          }
        }
      }

      .tips {
        margin-top: 12px;
        font-size: 12px;
        color: #888;
      }
    }
  }
}
</style>
